// Parse the "Missing linked Profile <id> (<type>), <id2> (<type2>)" comment that oracle-ohip writes
// when a reservation (or block) references a source profile that has not been synced to the target.
// The ids are SOURCE profile ids — the same key the source system (OXI/OHIP) re-emits on request.
//
// Returns a deduped array of { profileId, profileType }. Empty when the comment is not a
// missing-profile error (or only carries a non-numeric code, e.g. the old "CPF07" format).
export function parseMissingProfiles(comment) {
    if (!comment || typeof comment !== 'string') return [];
    // Accepts both the original "Missing linked Profile <id> (<type>)" and the generalised
    // "Missing linked Profile <id>, Reservation <id>" that oracle-ohip emits when a reservation's routing
    // references a record that is not synced yet. Each entry is tagged with its own kind so the requester
    // can ask the source for the right module.
    const marker = 'Missing linked ';
    const idx = comment.indexOf(marker);
    if (idx === -1) return [];
    // Only the missing-profile clause — stop at a newline so any story text appended after it
    // (GET/POST … lines) is not scanned for stray numbers.
    let tail = comment.slice(idx + marker.length);
    const nl = tail.search(/[\r\n]/);
    if (nl !== -1) tail = tail.slice(0, nl);
    // The clause is "<id> (<type>)[, <id> (<type>)]…". Source profile ids may be ALPHANUMERIC
    // (e.g. NMCC26), so extract the WHOLE id token per comma-separated segment — never a digit
    // substring, which turned "NMCC26" into "26" and produced bogus keyIds like "08".
    const out = [];
    const seen = new Set();
    // A segment is "[<Kind>] <id> [(<type>)]". The leading kind word is optional so the pre-existing
    // "Missing linked Profile 123 (Company), 456 (Group)" form still parses — a segment with no kind
    // inherits the last one seen, which for that form is Profile.
    let kind = 'Profile';
    for (const seg of tail.split(',')) {
        const m = seg.trim().match(/^(?:(Profile|Reservation|Block)\s+)?([^()\s]+)(?:\s*\(([^)]+)\))?/i);
        if (!m) continue;
        if (m[1]) kind = m[1][0].toUpperCase() + m[1].slice(1).toLowerCase();
        const profileId = m[2];
        if (!profileId || seen.has(kind + '|' + profileId)) continue;
        seen.add(kind + '|' + profileId);
        out.push({ profileId, profileType: (m[3] || '').trim() || null, kind });
    }
    return out;
}
